import React from 'react';
import PropTypes from 'prop-types';
import RpTable from 'rp-react-table';
import Header from './components/Header';
import columns from './columns';
import getSinceWin from './helpers/getSinceWin';

const Form = ({ data: { last14Days, profile, entries, bookedRides }, params: { type } }) => (
    <section className={`mp-form mp-form_${type}`}>
        <Header
            winsRuns={profile[`${type}Last14Days`] || undefined}
            sinceWin={getSinceWin(profile.sinceAWin, entries || bookedRides)}
            upcomingEntries={!!(entries || bookedRides || []).length}
            profileType={type}
        />
        <RpTable
            data={last14Days || []}
            columns={columns(type)}
            initialSortIdx={0}
            noDataText={`No form for this ${type}`}
            sortable
        />
        <div className="pp-bottomText">
            DIFF is the difference between the RPR the horse recorded and their expected RPR
        </div>
    </section>
);

const profileLast14Days = PropTypes.shape({
    wins: PropTypes.number,
    runs: PropTypes.number,
    percent: PropTypes.number,
});

Form.propTypes = {
    data: PropTypes.shape({
        last14Days: PropTypes.array,
        profile: PropTypes.shape({
            ownerLast14Days: profileLast14Days,
            jockeyLast14Days: profileLast14Days,
            trainerLast14Days: profileLast14Days,
            entries: PropTypes.array,
            bookedRides: PropTypes.array,
            sinceAWin: PropTypes.shape({}),
        }),
    }).isRequired,
    params: PropTypes.shape({
        type: PropTypes.string,
    }).isRequired,
};

export default Form;




// WEBPACK FOOTER //
// ./src/js/human/form/Form.jsx